import { DefineOwnModule } from 'stores/type';
import StorageManager, { StorageKey } from 'managers/storage.manager';

import { State, Getters, Actions, Mutations } from './types';

const moduleState: State = StorageManager.load(StorageKey.ENCYCLOPEDIA) || {
  encyclopediaShown: -1,
};

const storeModule: DefineOwnModule<State, Getters, Mutations, Actions> = {
  state: moduleState,

  getters: {
    encyclopediaTimestamp: (state) => state.encyclopediaShown,
  },

  actions: {
    encyclopediaShow({ commit }) {
      commit('ENCYCLOPEDIA_SHOW');
    },
  },

  mutations: {
    ENCYCLOPEDIA_SHOW(state) {
      state.encyclopediaShown = Date.now();
    },
  },
};

export default storeModule;
